import request from ".";

export const majorApi = {
  getMajor: (major: string) =>
    request.post(`AcademicsProg/getAcademicsProgByUrl?UniqueUrl=${major}`),
};
